import { formatCountdown } from '@/shared/domain'

export { formatCountdown }

export function formatResendLabel(seconds: number): string {
  return `Resend in ${formatCountdown(seconds)}`
}

export function formatTryAgainLabel(seconds: number): string {
  return `Try again in ${formatCountdown(seconds)}`
}
